import { memo } from 'react';
import PropTypes from 'prop-types';
import { PaginatedLoadingTable } from '@artprov/design-system';
import { columnasMatchingJudicialList } from '../columnasMatchingJudicialList';

/**
 * Tabla memoizada de Matching Judicial.
 * Estructura idéntica a MatchingBancarioTable.
 */
export const MatchingJudicialTable = memo(function MatchingJudicialTable({
    data,
    isLoading,
    onPageChange,
    headers,
    page,
    pageSize,
    setSelected,
    selected,
    emptyState,
    hasErrors,
    hasManualLoads,
    selectable = true,
    sortConfig,
    setSortConfig,
}) {
    return (
        <PaginatedLoadingTable
            selectable={selectable}
            columns={columnasMatchingJudicialList}
            data={data}
            sortable={true}
            sortConfig={sortConfig}
            setSortConfig={setSortConfig}
            isLoading={isLoading}
            showPagination={true}
            onPageChange={onPageChange}
            headers={headers}
            page={page}
            pageSize={pageSize}
            setSelected={setSelected}
            selected={selected}
            loadingIcon="progress_activity"
            loadingText="Solicitud en proceso"
            loadingIconVariant="primary"
            textVariant="subtitle1"
            textClassName="text-primary-10"
            emptyState={isLoading ? null : emptyState}
            flags={hasErrors || hasManualLoads}
            scrollArea={{ scrollY: false }}
        />
    );
});

MatchingJudicialTable.propTypes = {
    data: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired,
    onPageChange: PropTypes.func.isRequired,
    headers: PropTypes.object.isRequired,
    page: PropTypes.number.isRequired,
    pageSize: PropTypes.number.isRequired,
    setSelected: PropTypes.func.isRequired,
    selected: PropTypes.array.isRequired,
    emptyState: PropTypes.object.isRequired,
    hasErrors: PropTypes.bool.isRequired,
    hasManualLoads: PropTypes.bool.isRequired,
    selectable: PropTypes.bool,
    sortConfig: PropTypes.shape({
        key: PropTypes.string,
        direction: PropTypes.string,
    }).isRequired,
    setSortConfig: PropTypes.func.isRequired,
};
